import { LandingSubmitType } from "../../types/landingTypes";
import { AppState, DefaultProps } from "../../types/types";
import { Box, Button, Container, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import { useLandingContext } from "./LandingProvider";
import { useState } from "react";
import { getTenant, log } from "../../util/util";
import { useNavigate } from "react-router-dom";
import { loadSessionData } from "../../util/store";
import { LandingpageRequestResultLinkType, LandingpageRequestType, Tenant } from "../../types/apimodel";
import LinkedappBackend from "../../services/LinkedappBackend";

import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

interface LandingEmailAuswahlProps extends DefaultProps {
    appState: AppState,
    landingSubmitType: LandingSubmitType,
}



const LandingEmailAuswahl: React.FC<LandingEmailAuswahlProps> = props => {



    const { vorname,
        nachname,
        plz,
        vsnr,
        arrayOfEmailAdresses,
        emailchoosen,
        setEmailchoosen } = useLandingContext();

    const [emailRadio, setEmailRadio] = useState<string>('');
    const [newEmailInputVisible, setNewEmailInputVisible] = useState<boolean>(false);
    const [weiterButtonDisabled, setWeiterButtonDisabled] = useState<boolean>(true);
    const [newEmailInputError, setNewEmailInputError] = useState<string>('');

    const [technischerFehler, setTechnischerFehler] = useState(false);

    const [loading, setLoading] = useState(false);

    function getEnumLandingpageRequestResultLinkTypeByName(name: string): LandingpageRequestResultLinkType | undefined {
        for (const key in LandingpageRequestResultLinkType) {
            if (LandingpageRequestResultLinkType.hasOwnProperty(key)) {
                if (key === name) {
                    return LandingpageRequestResultLinkType[key as keyof typeof LandingpageRequestResultLinkType];
                }
            }
        }
        return undefined;
    }

    function weiter(): void {
        setLoading(true);

        let landingpageRequestType: LandingpageRequestType;
        landingpageRequestType = LandingpageRequestType.SIGNUP;
        let tenant: Tenant = getTenant(window.location.href);

        setTechnischerFehler(false);

        let lpfromlinktoken = loadSessionData("lpfromlinktoken");
        if (!lpfromlinktoken || lpfromlinktoken?.trim() === "") {
           

            LinkedappBackend.getLandingpageLink(vorname, nachname, plz, vsnr, landingpageRequestType, tenant, emailchoosen).then((data) => {

                log("Retrieved data: ", data);
                if (data.technicalError) {
                    setTechnischerFehler(true);
                } else {
                    log("Gültige Antwort erhalten");
                    if (data?.landingpageRequestResultLinkType !== undefined && getEnumLandingpageRequestResultLinkTypeByName(data.landingpageRequestResultLinkType.toLocaleString()) === LandingpageRequestResultLinkType.SIGNUP) {
                        let cid = loadSessionData("cid");
                        navigate("/landing/registrierendanke?cid=" + cid, { replace: true });
                    }
                }
                setLoading(false);
            }).catch(error => {
                console.log('error in getLandingpageLink: ' + JSON.stringify(error));
                setTechnischerFehler(true);
                //setIsLoading(false);
                setLoading(false);
            });

        } else {

            LinkedappBackend.getLandingpageLinkForEmail(lpfromlinktoken,landingpageRequestType,emailchoosen ).then((data) => {
                log("Retrieved data: ", data);
                if (data.technicalError) {
                    setTechnischerFehler(true);
                } else {
                    log("Gültige Antwort erhalten");
                    if (data?.landingpageRequestResultLinkType !== undefined && getEnumLandingpageRequestResultLinkTypeByName(data.landingpageRequestResultLinkType.toLocaleString()) === LandingpageRequestResultLinkType.SIGNUP) {
                        let cid = loadSessionData("cid");
                        navigate("/landing/registrierendanke?cid=" + cid, { replace: true });
                    }
                }
                setLoading(false);
            }).catch(error => {
                console.log('error in getLandingpageLink: ' + JSON.stringify(error));
                setTechnischerFehler(true);
                //setIsLoading(false);
                setLoading(false);
            });

        }

    }

    let newEmailValue = 'Neue E-Mail-Adresse hinterlegen';

    const navigate = useNavigate();

    let lpfromlinktoken = loadSessionData("lpfromlinktoken");

    if ((!vorname ||vorname?.trim() === "") || 
    (!nachname || nachname?.trim() === "") || 
    (!plz || plz?.trim() === "") || 
    (!vsnr || vsnr?.trim() === "")) {
        if (!lpfromlinktoken || lpfromlinktoken?.trim() === "") {
            log("Login Daten nicht vorhanden. Kehre zur Loginmase zurück");
            let cid = loadSessionData("cid");
            navigate("/landing/registrieren?cid=" + cid, { replace: true });
        }
    }

    const handleNewEmailInputChange = (event) => {
        let auswahl
        if (event) {
            auswahl = event.target.value;
        } else {
            auswahl = emailchoosen;
        }

        let regexStr = /^([a-zA-ZäÄöÖüÜ0-9-_.]+)@(([a-zA-ZäÄöÖüÜ0-9-])+(.)){1,}(\.)([a-zA-Z]){2,}$/;
        let regex = new RegExp(regexStr);

        setEmailchoosen(auswahl);
        let mailRegexValidated = regex.test(auswahl);
        if (mailRegexValidated === false) {
            setNewEmailInputError('Bitte geben Sie eine gültige Mailadresse an!');
            setWeiterButtonDisabled(true);
        } else {
            setNewEmailInputError(null);
            setWeiterButtonDisabled(false);
        }

    }


    const handleEmailRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let auswahl = event.target.value;
        setEmailRadio(auswahl);
        if (auswahl === newEmailValue) {
            setNewEmailInputVisible(true);
            setWeiterButtonDisabled(true);
            handleNewEmailInputChange(null);
        } else {
            setNewEmailInputVisible(false);
            setNewEmailInputError(null);
            setEmailchoosen(auswahl);
            setWeiterButtonDisabled(false);
        }
    };

    return (
        <Container maxWidth="lg" className="container" >
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Grid container spacing={0} className="container" sx={{ marginTop: { xs: '1rem', sm: '1rem', md: '3rem', lg: '3rem' } }}>
                <Grid item xs={12} md={6} sm={12} lg={12} sx={{ display: 'flex', justifyContent: 'left', flexDirection: 'column' }}>
                    <Box className={"answer-element "}
                        sx={{
                            backgroundColor: 'inherit',
                            borderLeft: '1px solid #ffffff42',
                            padding: '1rem',
                            borderRadius: "0px 20px 20px 20px",
                            background: props.appState?.customizing?.colors?.decentBackground || 'rgb(255 255 255 / 70%)',
                            "&:nth-child(even)": {
                                background: props.appState?.customizing?.elements?.backgroundEven || 'rgb(255 255 255 / 70%)',
                            },
                            "&:nth-child(odd)": {
                                background: props.appState?.customizing?.elements?.backgroundOdd || 'rgb(255 255 255 / 70%)',
                            },
                            ...props.appState?.customizing?.elements?.styleOverrides ?? {},
                        }}>
                        <Typography variant='h1' sx={{ fontSize: { xs: '1.3rem', sm: '1.3rem', md: '2rem', lg: '2rem' } }}>Guten Tag {vorname != null ? vorname : ""} {nachname != null ? nachname : ""}, </Typography>
                        <p>
                            wir freuen uns, dass Sie sich Ihr Digitales Postfach einrichten.
                        </p>
                    </Box>
                </Grid>
                <Grid item xs={12} md={12} sm={12} lg={12} sx={{ display: 'flex', justifyContent: 'left', flexDirection: 'column' }}>
                    <h1>Ihre E-Mail-Adresse</h1>
                </Grid>
                <Grid item xs={12} md={12} sm={12} lg={12} sx={{ display: 'flex', justifyContent: 'left', flexDirection: 'column' }}>

                    <Box className={"answer-element "}
                        sx={{
                            backgroundColor: 'inherit',
                            borderBottom: '1px solid',
                            borderBottomColor: '#ffffff',
                            borderLeft: '1px solid #ffffff42',
                            padding: '1rem',
                            background: props.appState?.customizing?.colors?.decentBackground || 'linear-gradient(170deg, rgb(255 255 255 / 15%) 0%, rgba(255,255,255,0) 100%)',
                            "&:nth-child(even)": {
                                background: props.appState?.customizing?.elements?.backgroundEven || 'linear-gradient(170deg, rgb(255 255 255 / 15%) 0%, rgba(255,255,255,0) 100%)',
                            },
                            "&:nth-child(odd)": {
                                background: props.appState?.customizing?.elements?.backgroundOdd || 'linear-gradient(170deg, rgb(255 255 255 / 15%) 0%, rgba(255,255,255,0) 100%)',
                            },
                            ...props.appState?.customizing?.elements?.styleOverrides ?? {},
                        }}>

                        Bitte geben Sie an, welche E-Mail-Adresse Sie künftig für Ihr Digitales Postfach nutzen wollen.<br />

                        <FormControl component="fieldset" className="radio" sx={{ marginTop: "2em" }}>
                            <RadioGroup aria-label="select" value={emailRadio} >
                                {arrayOfEmailAdresses.value.map(element => {

                                    return (<FormControlLabel key={element} value={element} control={<Radio />} label={<Box component="span" dangerouslySetInnerHTML={{ __html: element }} />} onChange={handleEmailRadioChange} sx={{ paddingBottom: { xs: 'inherit', md: 'inherit' } }} />);
                                })}
                                <FormControlLabel key="newEmail" value={newEmailValue} control={<Radio />} label={<Box component="span" dangerouslySetInnerHTML={{ __html: "Neue E-Mail-Adresse hinterlegen" }} />} onChange={handleEmailRadioChange} sx={{ paddingBottom: { xs: 'inherit', md: 'inherit' } }} />
                            </RadioGroup>
                        </FormControl>
                    </Box>
                </Grid>
                {newEmailInputVisible && <Grid item xs={12} md={12} sm={12} lg={12} sx={{ display: 'flex', justifyContent: 'left', flexDirection: 'column' }}>

                    <Box className={"answer-element "}
                        sx={{
                            backgroundColor: 'inherit',
                            borderBottom: '1px solid',
                            borderBottomColor: '#ffffff',
                            borderLeft: '1px solid #ffffff42',
                            padding: '1rem',
                            background: props.appState?.customizing?.colors?.decentBackground || 'linear-gradient(170deg, rgb(255 255 255 / 15%) 0%, rgba(255,255,255,0) 100%)',
                            "&:nth-child(even)": {
                                background: props.appState?.customizing?.elements?.backgroundEven || 'linear-gradient(170deg, rgb(255 255 255 / 15%) 0%, rgba(255,255,255,0) 100%)',
                            },
                            "&:nth-child(odd)": {
                                background: props.appState?.customizing?.elements?.backgroundOdd || 'linear-gradient(170deg, rgb(255 255 255 / 15%) 0%, rgba(255,255,255,0) 100%)',
                            },
                            ...props.appState?.customizing?.elements?.styleOverrides ?? {},
                        }}>
                        <TextField onChange={handleNewEmailInputChange} onBlur={handleNewEmailInputChange} onClick={handleNewEmailInputChange} value={emailchoosen}
                            sx={{ width: '100%' }}
                            label="Ihre Mailadresse"
                            error={(newEmailInputError && newEmailInputError !== null) || false} helperText={newEmailInputError}
                        />
                    </Box>
                </Grid>}

            </Grid>
            <Grid container spacing={3} className="row buttonrow">
                {technischerFehler && <Grid item xs={12}>
                    Es gab einen technischen Fehler. Bitte probieren Sie es später noch einmal.
                </Grid>}
                <Grid item xs={12}>
                    <Button sx={{ fontSize: "75%", maxWidth: "140px", minWidth: "140px" }} onClick={weiter} disabled={weiterButtonDisabled}>WEITER</Button>

                </Grid>
            </Grid>

        </Container>
    );

}

export default LandingEmailAuswahl;